import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { FALLBACK_ACCOUNT_CUSTOMIZED_TEXTS, OAuthProvider } from '@platform-frontend/account';
import { PollingConfiguration, extendPollingConfiguration } from '@platform-frontend/platform';
import { TranslationId, TypedChanges } from '@platform-frontend/util';
import { EMPTY, Observable } from 'rxjs';
import { ACCOUNT_UI_MATOMO_EVENT_CATEGORY_ACCOUNT } from '../account-ui-matomo-events';
import { ACCOUNT_UI_TRANSLOCO_SCOPE } from '../account-ui-transloco-scope';

@Component({
  selector: 'yat-o-auth-ui',
  templateUrl: './o-auth-ui.component.html',
  styleUrls: ['./o-auth-ui.component.scss'],
  providers: [provideTranslocoScope(ACCOUNT_UI_TRANSLOCO_SCOPE)]
})
export class OAuthUiComponent implements OnChanges {
  @Input()
  pollingConfiguration: PollingConfiguration;

  @Input()
  provider: OAuthProvider | null = null;

  @Input()
  termsAndPrivacyPolicyText?: TranslationId;

  @Output()
  cancel: EventEmitter<void> = new EventEmitter();

  readonly MATOMO_EVENT_CATEGORY_ACCOUNT = ACCOUNT_UI_MATOMO_EVENT_CATEGORY_ACCOUNT;

  extendedConfiguration: PollingConfiguration;
  proceeding = false;
  displayedTermsAndPrivacyPolicyText: TranslationId = FALLBACK_ACCOUNT_CUSTOMIZED_TEXTS('pureSignIn').oAuth.termsAndPrivacyPolicy;

  ngOnChanges(changes: TypedChanges<OAuthUiComponent>): void {
    if (changes.pollingConfiguration) {
      this.extendedConfiguration = extendPollingConfiguration(this.pollingConfiguration).withComplete(() => this.setToProceeding());
    }
    if (changes.termsAndPrivacyPolicyText) {
      this.displayedTermsAndPrivacyPolicyText = this.termsAndPrivacyPolicyText ?? FALLBACK_ACCOUNT_CUSTOMIZED_TEXTS('pureSignIn').oAuth.termsAndPrivacyPolicy;
    }
  }

  private setToProceeding(): Observable<unknown> {
    this.proceeding = true;
    return EMPTY;
  }

  cancelAuthentication(): void {
    this.cancel.next();
  }
}
